import styled from "styled-components";

export const Container = styled.h2`
  align-items: center;
  background-color: #fa821f;
  display: flex;
  font-size: 25px;
  font-weight: bold;
  height: 60px;
  justify-content: center;
  margin: 25px 0 0;
  width: 100%;
`;
